import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export default function CheckInOutModal({
  show,
  onHide,
  onConfirm,
  isCheckIn,
  volunteerName,
  eventTitle,
  selfService = false,
  disabled = false,
}) {
  const { t } = useTranslation()

  let title
  let details
  if (selfService) {
    title = isCheckIn
      ? t('selfCheckIn.confirm_in_title', 'Check In')
      : t('selfCheckIn.confirm_out_title', 'Check Out')
    details = isCheckIn
      ? t('selfCheckIn.confirm_in_details', 'Check in to {{title}} now?', {
          title: eventTitle,
        })
      : t('selfCheckIn.confirm_out_details', 'Check out of {{title}} now?', {
          title: eventTitle,
        })
  } else {
    title = isCheckIn
      ? t('VolunteerListScreen.check_in_title', 'Volunteer Check In {{name}}', {
          name: volunteerName,
        })
      : t(
          'VolunteerListScreen.check_out_title',
          'Volunteer Certification of Completion {{name}}',
          { name: volunteerName },
        )
    details = isCheckIn
      ? t(
          'VolunteerListScreen.check_in_details',
          'A Check In timestamp will be created for this user.',
        )
      : t(
          'VolunteerListScreen.check_out_details',
          'A Check Out timestamp will be created for this user.',
        )
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{details}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('VolunteerListScreen.cancel_label', 'Cancel')}
        </Button>
        <Button
          variant="primary"
          disabled={disabled}
          onClick={e => {
            // prevent double-click/double-firing
            if (disabled) {
              e.preventDefault()
              e.stopPropagation()
              return
            }
            e.preventDefault()
            e.stopPropagation()
            if (onConfirm) {
              onConfirm()
            }
          }}
        >
          {isCheckIn
            ? t('VolunteerListScreen.check_in_button', 'Check In')
            : t('VolunteerListScreen.check_out_button', 'Check Out')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
